module.exports = __webpack_public_path__ + "static/media/logo-ibk@2x.45b8c635.png";